import { render, staticRenderFns } from "./prosespesanan.vue?vue&type=template&id=20ba6cc6"
import script from "./prosespesanan.vue?vue&type=script&lang=js"
export * from "./prosespesanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports